/* eslint-disable no-param-reassign, max-lines-per-function */
import "./product-desktop-grid-toggle.scss";
import { api } from "jiffy-api";
import { store } from "jiffy-store";
import { track } from "jiffy-analytics";

const $section = document.querySelector("#product-details__section");
const getProductGrid = () => document.querySelector("#product-grid");
const getLoaderButtons = () => document.querySelectorAll(".js-product-desktop-grid-toggle__button");
const productDataSource = document.querySelector(".js-product-details-favorite-icon");
const { productId, productName, businessLine } = productDataSource ? productDataSource.dataset : {};
const compositionDataSource = () =>
  document.querySelector(".product-colors-slider__item-link--active");

class Loader {
  constructor() {
    this.$buttons = getLoaderButtons();
    this.defaultTextButtons = [...this.$buttons].map(button => button.textContent);
    this.loadingText = "Loading Bulk Buyer Order Entry…";
  }

  show() {
    this.$buttons.forEach($button => {
      const { loading } = $button.dataset;
      if (loading) $button.textContent = this.loadingText;
      $button.disabled = true;
    });
  }

  hide() {
    this.$buttons.forEach(($button, idx) => {
      $button.textContent = this.defaultTextButtons[idx];
      $button.disabled = false;
    });
  }

  hideButtons() {
    this.$buttons.forEach($button => {
      const { hideable } = $button.dataset;
      if (hideable) $button.classList.add("hide");
    });
  }

  showAllButtons() {
    this.$buttons.forEach($button => {
      $button.classList.remove("hide");
    });
  }
}
const loader = new Loader();

export const scrollToGrid = () =>
  new Promise(resolve => {
    const $productGrid = getProductGrid();
    if (!$productGrid) return;

    const isReady = () => !$productGrid.classList.contains("product-grid--loading");

    const scrollTo = () => {
      $productGrid.scrollIntoView({
        block: "start"
      });
      resolve();
    };

    if (isReady()) {
      scrollTo();
    } else {
      const intervalId = setInterval(() => {
        if (isReady()) {
          clearInterval(intervalId);
          scrollTo();
        }
      }, 500);
    }
  });

export const persistState = state => {
  const payload = {
    preference_key: "show_desktop_grid",
    preference_value: state,
    set_preference_cookie: state
  };

  // HB-1950: silent — failure to persist a cosmetic UI preference is not
  // actionable triage. Bot/scraper traffic with no session cookie 422s here
  // even though the user-visible behavior is fine.
  api.jiffyshirts.preference(payload, { silent: true }).then(() => {
    $section.setAttribute("data-displayed", state);
  });
};

const toggleShowingGrid = isShow => {
  $section.classList.toggle("hide", !isShow);
  persistState(isShow);
};

const loadGrid = () =>
  $.ajax({
    url: $section.getAttribute("data-load-url"),
    type: "GET",
    dataType: "json",
    success: resp => {
      $section.insertAdjacentHTML("beforeend", resp.grid);
      store.pdp.change({ productGridLoaded: true });
    }
  });

const initLoadButton = $button => {
  const buttonLabel = $button.textContent.trim();
  const buttonClickEvent = () => {
    const { compositionId } = compositionDataSource()?.dataset || {};
    track("bulk_buyer_form_shown", {
      product_id: productId,
      product_name: productName,
      spree_composition_id: compositionId,
      button_label: buttonLabel,
      business_line: businessLine
    });
    toggleShowingGrid(true);
    scrollToGrid().then(() => {
      loader.hide();
      loader.hideButtons();
    });
  };

  $button.addEventListener("click", ({ target: $target }) => {
    if (getProductGrid() == null) {
      loader.show();
      loadGrid().then(() => {
        buttonClickEvent();
      });
    } else {
      buttonClickEvent();
    }

    if ($target.blur) $target.blur();
  });
};

export default () => {
  if (!$section) return;
  const $hideLink = document.querySelector("#product-details__hide-details");

  if ($hideLink) {
    $hideLink.addEventListener("click", event => {
      event.preventDefault();
      toggleShowingGrid(false);
      loader.showAllButtons();
    });
  }

  getLoaderButtons().forEach(initLoadButton);
};
